export default __webpack_public_path__ + "static/media/sports12.ece5b2f4.jpg";